var _circle, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgS24(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 60,
    viewBox: "0 0 62 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 41,
    r: 19,
    fill: "#BB91F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8438 40.625C29.8641 40.625 32.3125 38.1766 32.3125 35.1562C32.3125 32.1359 29.8641 29.6875 26.8438 29.6875C23.8234 29.6875 21.375 32.1359 21.375 35.1562C21.375 38.1766 23.8234 40.625 26.8438 40.625Z",
    stroke: "#121212",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1562 40.625C50.1766 40.625 52.625 38.1766 52.625 35.1562C52.625 32.1359 50.1766 29.6875 47.1562 29.6875C44.1359 29.6875 41.6875 32.1359 41.6875 35.1562C41.6875 38.1766 44.1359 40.625 47.1562 40.625Z",
    stroke: "#121212",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3125 35.1562H41.6875",
    stroke: "#121212",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5625 23.4375H60.4375",
    stroke: "#121212",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8125 23.4374L29.4414 9.68737C29.5865 9.47898 29.7801 9.30908 30.0057 9.19238C30.2312 9.07568 30.4817 9.0157 30.7356 9.01762C30.9895 9.01955 31.2391 9.08332 31.4628 9.20342C31.6866 9.32352 31.8776 9.49634 32.0195 9.7069L35.6914 15.2342C35.8334 15.4519 36.0274 15.6306 36.2559 15.7544C36.4844 15.8781 36.7402 15.9429 37 15.9429C37.2598 15.9429 37.5156 15.8781 37.7441 15.7544C37.9726 15.6306 38.1666 15.4519 38.3086 15.2342L41.9805 9.7069C42.1224 9.49634 42.3134 9.32352 42.5372 9.20342C42.7609 9.08332 43.0105 9.01955 43.2644 9.01762C43.5183 9.0157 43.7688 9.07568 43.9943 9.19238C44.2199 9.30908 44.4135 9.47898 44.5586 9.68737L54.1875 23.4374",
    stroke: "#121212",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS24);
export default __webpack_public_path__ + "static/media/s2-4.6e2dd4d51582e6342f33e77acbc89647.svg";
export { ForwardRef as ReactComponent };